<template>
    <v-container fluid >
        <v-data-iterator
            :items="items"
            hide-default-footer
        >
            <template v-slot:header>
                <v-toolbar
                    class="mb-2" color="indigo darken-5" dark flat
                >
                    <v-toolbar-title>保險公司資訊</v-toolbar-title>
                </v-toolbar>
            </template>
            <template v-slot:default="props">
                <v-row v-for="item in props.items"
                    :key="item.id"
                    :item-per-page.sync="pagination.itemsPerPage"
                >
                    <v-col>
                        <v-card>
                            <v-card-title class="subheading font-weight-bold"><a :href="item.link" target="_blank"  rel="noopener noreferrer">{{item.title}}</a></v-card-title>
                            <v-card-text>{{item.description}}</v-card-text>
                        </v-card>
                        
                    </v-col>
                </v-row>
            </template>
        </v-data-iterator>
        <v-pagination v-model="pagination.current" :length="pagination.total" @input="onPageChange"></v-pagination>
    </v-container>
</template>
<script>
import InsuranceCompanyInformationDataService from '../../services/InsuranceCompanyInformationDataService'

export default {
    name: "insurance-company-information-viewer",
    props:{
        insurance_company_id: Number
    },
    data(){
        return {
            pagination: {
                current: 1,
                total: 0,
                itemsPerPage: 5
            },
            items:[]
        }
    },
    watch:{
        insurance_company_id:function(){
            this.searchRecord()
        }
    },
    computed:{
        showContent(){
            console.log((this.items.length>0),'showContent')
            return (this.items.length > 0)
        }
    },
    methods:{
        searchRecord(){
            //取得資料
            InsuranceCompanyInformationDataService.findByCondition(this.insurance_company_id,this.pagination.current, this.pagination.itemsPerPage).then((response) =>{ 
                //console.log(response, "searchRecord.response")
                if (response.result === true){
                    this.items = response.list.map(this.mapData)
                    this.pagination.total = response.last_page
                } else {
                    this.items = []
                }
            })
            .catch((e) => {
                console.log(e);
            });
            //console.log(this.informations, 'searchRecord, informations')
        },
        mapData(item){
            return {
                id: item.id,
                insurance_company_id: item.insurance_company_id,
                title: item.title,
                link: item.link,
                description: item.description,
                file_name: item.file_name,
                file_type: item.file_type,
                publish_date: item.publish_date
            }
        },
        onPageChange(){
            this.searchRecord();
        }
    }
}
</script>
